import { render, staticRenderFns } from "./index.vue?vue&type=template&id=d8acc886&scoped=true&"
var script = {}
import style0 from "./index.vue?vue&type=style&index=0&id=d8acc886&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d8acc886",
  null
  
)

export default component.exports